const FOLDER_PERMISSION = {
  VIEWER: 'VIEWER',
  EDITOR: 'EDITOR',
}

const FOLDER_SHARE_TYPE = {
  USER: 'USER',
  DISTRICT: 'DISTRICT',
}

const FOLDER_ROLE = {
  OWNER: 'OWNER',
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER',
  NONE: 'NONE',
}

module.exports = {
  FOLDER_PERMISSION,
  FOLDER_SHARE_TYPE,
  FOLDER_ROLE,
}
